import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CoreService } from '@box-core/services';
import { Cuisine } from '@box-types';

@Component({
  selector: 'landing-cuisines',
  templateUrl: './landing-cuisines.component.html',
  styleUrls: ['./landing-cuisines.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LandingCuisinesComponent implements OnInit {
  public cuisines: Cuisine[];

  constructor(private coreService: CoreService) {}

  ngOnInit(): void {
    this.cuisines = this.coreService.foodCuisines.getValue();
  }
}
